import styled from '@emotion/styled';
import { xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

export const HeadingText = styled.h2`
  font-weight: ${token('font.heading.medium')};
  margin-top: 0;
`;

export const ProgressBarContainer = styled.div<{ backgroundColor?: string }>`
  span {
    ${(props) => props.backgroundColor && `background-color: ${props.backgroundColor};`}
  }
`;

export const cardStyles = xcss({
  borderColor: 'color.border',
  borderWidth: 'border.width',
  borderStyle: 'solid',
  borderRadius: 'border.radius.200',
  flex: 1,
});
